import { useLocation } from '@remix-run/react'
import { useMemo } from 'react'
import { aOrganization, aUser, useAtomValue } from '~/atoms'
import type { Listing } from '~/models'
import Detail from './Detail'
import OffMarket from './OffMarket'
import PrivateListing from './Private'

type ListingDetailLayoutProps = {
  canEdit: boolean
  listing: Listing
}

export default function ListingDetailLayout({
  canEdit,
  listing,
}: ListingDetailLayoutProps) {
  const organization = useAtomValue(aOrganization)
  const user = useAtomValue(aUser)
  const location = useLocation()

  const showBrokers = useMemo(() => {
    return (
      location.search.includes('brokers=true') ||
      !location.search.includes('report')
    )
  }, [location])

  if (!user && listing.isPublic === false) {
    return <PrivateListing listing={listing} />
  } else if (
    user ||
    listing.status === 'active' ||
    listing.status === 'pending'
  ) {
    return (
      <Detail
        user={user}
        listing={listing}
        organization={organization!}
        canEdit={canEdit}
        location={location}
        showBrokers={showBrokers}
      />
    )
  }
  return (
    <OffMarket
      listing={listing}
      organization={organization!}
      canEdit={canEdit}
      showBrokers={showBrokers}
    />
  )
}
